import { jsxs, jsx } from 'react/jsx-runtime';
import { Badge } from '@sbt-web/ui';
import styles from './index.module.css.js';

const Badges = ({ isGallerized, isUrgent }) => {
    if (!isGallerized && !isUrgent)
        return null;
    return (jsxs("div", { className: styles.badges, children: [isGallerized && jsx(GallerizedBadge, {}), isUrgent && jsx(UrgentBadge, {})] }));
};
const GallerizedBadge = () => (jsx(Badge, { flavor: "small", themed: true, rounded: true, children: "Vetrina" }));
const UrgentBadge = () => (jsx(Badge, { flavor: "small", themed: true, rounded: true, inverted: true, children: "Urgente" }));

export { Badges };
//# sourceMappingURL=index.js.map
